import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatChipsModule } from '@angular/material/chips';
import { MatSliderModule } from '@angular/material/slider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { QuickPlayPanelComponent } from './components/quick-play-panel/quick-play-panel.component';
import { GenreSelectionComponent } from './components/genre-selection/genre-selection.component';
import { VoiceSpeechComponent } from './components/voice-speech/voice-speech.component';
import { VoiceSpeechDialogComponent } from './components/voice-speech/voice-speech-dialog.component';
import { QuickPlayService } from './services/quick-play.service';

@NgModule({
  declarations: [
    QuickPlayPanelComponent,
    GenreSelectionComponent,
    VoiceSpeechComponent,
    VoiceSpeechDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    MatChipsModule,
    MatSliderModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatMenuModule,
    MatDividerModule,
    MatSnackBarModule,
    MatFormFieldModule,
    MatInputModule,
    MatSlideToggleModule,
    MatCardModule,
    MatSelectModule
  ],
  exports: [
    QuickPlayPanelComponent
  ],
  providers: [
    QuickPlayService
  ]
})
export class QuickPlayModule { }